import React, { useEffect, useState } from "react";
// import EventSignUpInline from "../Home/EventSignUp/EventSignUpInline";
import EventModalExcerpt from "./EventModalExcerpt";
import fysee25Logo from "../../../Common/_assets/img/fysee25/fysee25logo.png";
import { listEvents } from "../../../utils/api/helpers/event";
import { Modal } from "react-bootstrap";

const EventListModal = ({ showEventListModal, setShowEventListModal }) => {
	const [eventList, setEventList] = useState(null);
	const [loaded, setLoaded] = useState(false);
	const [showEventList, setShowEventList] = useState(false);

	useEffect(() => {
		let subscribed = true;
		if (subscribed) {
			listEvents().then((result) => {
				if (result.data) {
					setEventList(result.data);
					setLoaded(true);
					setTimeout(() => {
						setShowEventList(true);
					}, 500);
				}
			});
		}
		return () => (subscribed = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Modal
			centered
			show={showEventListModal}
			onHide={() => {
				setShowEventListModal(false);
				window.localStorage.setItem("showEventListModal", "false");
			}}
		>
			<Modal.Body className={"p-0 events__home-modal-container"}>
				{!loaded ? (
					<div
						className={
							"w-100 text-uppercase nf-sans my-5 font-weight-bold text-center"
						}
						style={{ fontSize: "1rem", color: "#000" }}
					>
						Loading Events
					</div>
				) : (
					<>
						<div className="events__home-modal">
							<div className={"events-grid pb-3"}>
								<div
									className={
										"pt-3 pb-3 pb-sm-0 d-flex flex-column flex-sm-row w-100 align-items-center justify-content-sm-between"
									}
								>
									<div
										className={""}
										style={{ maxWidth: "240px" }}
									>
										<img
											src={fysee25Logo}
											className={"w-100"}
											alt={"FYSEE"}
										/>
									</div>
									<div
										className={
											"events-grid-tagline nf-sans-cond pl-3 pt-1 pt-sm-0 pe-0 ms-0 align-self-center align-self-sm-end"
										}
									>
										<div>
											The shows you love
											<br />
											In the city you love
										</div>
									</div>
								</div>
								<div
									className={
										"d-flex flex-column gap-3 w-100 transition-all"
									}
									style={{ opacity: showEventList ? 1 : 0 }}
								>
									{eventList ? (
										eventList.map((o, i) => {
											if (i < 3) {
												return (
													<EventModalExcerpt
														key={i}
														i={i}
														event_object={o}
													/>
												);
											}
											return null;
										})
									) : (
										<></>
									)}
								</div>
							</div>
						</div>
						<div
							className={
								"d-flex flex-column flex-sm-row gap-3 p-3"
							}
						>
							<div className={"d-flex flex-grow-1"}>
								<a
									href={"/events"}
									className={
										"button-dark nf-sans-cond w-100 d-flex gap-2 align-items-center justify-content-center"
									}
								>
									View All Events
								</a>
							</div>
							<div className={"d-flex flex-grow-1"}>
								<a
									href={"/"}
									onClick={(e) => {
										e.preventDefault();
										window.localStorage.setItem(
											"showEventListModal",
											"false",
										);
										setShowEventListModal(false);
									}}
									className={
										"button-dark button-dark-border nf-sans-cond  w-100 d-flex gap-2 align-items-center justify-content-center"
									}
								>
									<div>Continue to Netflix FYC</div>
									<div>
										<svg
											viewBox="0 0 24 24"
											width="16"
											height="16"
											stroke="currentColor"
											strokeWidth="2"
											fill="none"
											strokeLinecap="round"
											strokeLinejoin="round"
										>
											<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
											<polyline points="10 17 15 12 10 7"></polyline>
											<line
												x1="15"
												y1="12"
												x2="3"
												y2="12"
											></line>
										</svg>
									</div>
								</a>
							</div>
						</div>
					</>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default EventListModal;
